import moment from 'moment';

const getLocale = () => {
    // Por lo que parece, por defecto, en español, solo sale el punto separando millares si la cantidad es más de 10.000
    // return 'es-ES';
    return 'de-DE';
};

const filters = {
    yuriSetTimeZone(value) {
        const date = moment(value).tz('Europe/Madrid', true);
        return date.toString();
    },
    /**
     * @param {*} value to filter
     * @return {String} formated date
     * YuriDatePicker require a specific format for its prop input
     */
    yuriDatePickerFormat(value) {
        let date = moment(value);
        date = moment(date.tz('Europe/Madrid').format('YYYY-MM-DDTHH:mm:ss.SS'));
        return date.toString();
    },
    /**
     * @param {*} value to filter
     * @return {String} formated date
     */
    yuriDateFormat(value) {
        const date = moment(value);
        if (date.isValid()) {
            return date.tz('Europe/Madrid').format('DD-MMM-YYYY | HH:mm [h]');
        } else {
            return '';
        }
    },
    /**
     * @param {*} value to filter
     * @return {String} formated date
     */
    yuriDateFormat2(value) {
        // eslint-disable-next-line radix
        const date = moment(new Date(parseInt(value)));
        return date.tz('Europe/Madrid').format('DD-MMM-YYYY | HH:mm [h]');
    },
    /**
     * @param {*} value to filter
     * @param {Number} decimals length
     * @return {String} formated number
     */
    yuriDecimals(value, decimals = 6) {
        if (value === 0 || value === '0') return '0';

        return value
            ? Number(value).toLocaleString(getLocale(), {
                maximumFractionDigits: decimals,
                minimumFractionDigits: decimals
            })
            : 0;
    },
    /**
     * @param {*} value to filter
     * @param {*} decimals number of decimals
     * @return {String} formated number
     */
    yuriCurrency(value, decimals = 2) {
        // return value ? Number(value).toLocaleString('es', { style: 'currency', currency: 'EUR' }) : '-';
        // Quitado símbolo de moneda a petición de Fernando
        return value || value === 0 || value === '0'
            ? Number(value).toLocaleString(getLocale(), {
                maximumFractionDigits: decimals,
                minimumFractionDigits: decimals
            })
            : '-';
    },
    yuriAbs(value) {
        return Math.abs(value);
    },
    /**
     * @param {*} value to filter
     * @return {String} formated number
     */
    yuriLongCurrency(value) {
        if (value) {
            const numberValue = Number(value).toLocaleString(getLocale(), {
                maximumFractionDigits: '6',
                minimumFractionDigits: '6'
            });
            // return `${numberValue} €`;
            // Quitado símbolo de moneda a petición de Fernando
            return `${numberValue}`;
        } else {
            return '-';
        }
    }
};

export default filters;
